import PropTypes from 'prop-types';

import Charges from './Charges';
import Flight from './Flight';

export const FlightOption = {
  flightSegments: PropTypes.arrayOf(PropTypes.shape(Flight)),
  charges: PropTypes.shape(Charges),
};

const PerDirection = PropTypes.arrayOf(PropTypes.shape(FlightOption));

const FlightOptions = {
  inbound: PerDirection,
  outbound: PerDirection,
};

export const selectedFlightOption = {
  inbound: PropTypes.shape(FlightOption).isRequired,
  outbound: PropTypes.shape(FlightOption).isRequired,
};

export const SetSelectedFlightOption = {
  setInbound: PropTypes.func.isRequired,
  setOutbound: PropTypes.func.isRequired,
};

export default FlightOptions;
